import { render, staticRenderFns } from "./CR_overseasServiceProvider.vue?vue&type=template&id=820d7e6e&"
import script from "./CR_overseasServiceProvider.vue?vue&type=script&lang=js&"
export * from "./CR_overseasServiceProvider.vue?vue&type=script&lang=js&"
import style0 from "./CR_overseasServiceProvider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports